import DigitalStoreSDK from '@redant/cha-digital-store-client-sdk'

export default new DigitalStoreSDK({
  baseUrl: ''
})



// WEBPACK FOOTER //
// ./src/digitalStoreSdk.js